module.exports = __webpack_public_path__ + "static/media/icon-edge-scalloped.4dbf66bb.svg";